import { render, staticRenderFns } from "./TDot.vue?vue&type=template&id=691df4a0&scoped=true&"
import script from "./TDot.vue?vue&type=script&lang=js&"
export * from "./TDot.vue?vue&type=script&lang=js&"
import style0 from "./TDot.vue?vue&type=style&index=0&id=691df4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691df4a0",
  null
  
)

/* custom blocks */
import block0 from "./TDot.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports